import "./App.css";
import Title from "./Title/Title";

function App() {
	return (
		<div className="App">
			<Title />
		</div>
	);
}

export default App;
